import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import NewValuePropositionBig from '../NewValuePropositionBig/'
import NewValuePropositionSmall from '../NewValuePropositionSmall'
import {
  SHOP_TIRES_TITLE,
  SPECIALS_TITLE,
  SERVICES_TITLE,
  SHOP_TIRES_DESCRIPTION,
  APPOINTMENT_DESCRIPTION
} from '../../constant'

const NewValuePropositionWrapper = ({
  hover: {
    tire,
    appointment,
    specials,
    services
  },
  handleShopByVehicleClick = () => {},
  onClick = () => {},
  appointmentTitle,
  ...props
}) =>
  <Wrapper>
    <NewValuePropositionBig
      asset={ tire ? 'tire-white' : 'tire-bright-red' }
      title={ SHOP_TIRES_TITLE }
      description={ SHOP_TIRES_DESCRIPTION }
      alt="tire"
      isHover={ tire }
      click={ handleShopByVehicleClick }
      { ...props } />
    <NewValuePropositionBig
      asset={ appointment ? 'book-appointment-white' : 'book-appointment-red' }
      title={ appointmentTitle }
      description={ APPOINTMENT_DESCRIPTION }
      alt="appointment"
      isHover={ appointment }
      click={ onClick }
      { ...props } />
    <Row>
      <NewValuePropositionSmall
        asset={ specials ? 'view-specials-white' : 'special-offers' }
        title={ SPECIALS_TITLE }
        link="/deals"
        alt="specials"
        { ...props } />
      <NewValuePropositionSmall
        asset={ services ? 'view-services-white' : 'services' }
        title={ SERVICES_TITLE }
        link="/services"
        alt="services"
        { ...props } />
    </Row>
  </Wrapper>

NewValuePropositionWrapper.propTypes = {
  appointmentTitle: PropTypes.string,
  handleShopByVehicleClick: PropTypes.func,
  hover: PropTypes.shape({
    tire: PropTypes.bool,
    appointment: PropTypes.bool,
    specials: PropTypes.bool,
    services: PropTypes.bool
  }),
  onClick: PropTypes.func
}

export default NewValuePropositionWrapper

const Wrapper = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 50px;
    right: 50px;
    width: 460px;
    z-index: 1;
  `}
  ${Media.mobile`
    margin: 20px 0 15px;
    padding: 0 20px;
    width: 100%;
  `}
`

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
